import styled from '@emotion/styled';


export const MainContainer = styled.div`
  position: relative;
  opacity: 0;
  transition: opacity 130ms ease;
  &._loaded {
    opacity: 1;
  }
`;
